// // import React from 'react';
// // import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// // import LoginPage from './pages/Authentication/Login';
// // import ForgotPasswordPage from './pages/Authentication/ForgotPassword';
// // import EmployeeDashboard from './pages/Employee/EmployeeDashboard';
// // import HRDashboard from './pages/HR/HRDashboard';
// // import { Manager } from './pages/Manager/manager';
// // import VerifyEmail from './pages/verifyEmail';
// // import SetPassword from './pages/setPassword';
// // import RegisterPage from './pages/Authentication/RegistrationPage';
// // import GenerateOTP from './pages/Authentication/GenerateOTP';
 
// // const App = () => {
// //   return (
// //     <Router>
// //       <Routes>
       
// //         <Route path='/' element={<LoginPage />} />
// //         <Route path='/register' element={<RegisterPage />} />
// //         <Route path='/generate-otp' element={<GenerateOTP />} />
// //         <Route path="/login" element={<LoginPage />} />
// //         <Route path="/forgot-password" element={<ForgotPasswordPage />} />
// //         <Route path='/Employee-Dashboard' element={<EmployeeDashboard />} />
// //         <Route path='/Manager' element={<Manager />} />
// //         <Route path='/HRDashboard' element={<HRDashboard />} />
// //         <Route path="/set-password" element={<SetPassword />} />
// //         <Route path="/verify-email/:token" element={<VerifyEmail />} />
// //       </Routes>
// //     </Router>
// //   );
// // };
 
// // export default App;
 
// import React, { useState, useEffect } from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { keyframes } from '@emotion/react';
// import styled from '@emotion/styled';
 
// import LoginPage from './pages/Authentication/Login';
// import ForgotPasswordPage from './pages/Authentication/ForgotPassword';
// import EmployeeDashboard from './pages/Employee/Dashboard/EmployeeDashboard';
// import HRDashboard from './pages/HR/DashBoard/HRDashboard';
// import { Manager } from './pages/Manager/Dashboard/manager';
// import VerifyEmail from './pages/Authentication/verifyEmail';
// import SetPassword from './pages/Authentication/setPassword';
// import RegisterPage from './pages/Authentication/RegistrationPage';
// import GenerateOTP from './pages/Authentication/GenerateOTP';
// import PushNotificationManager from './components/PushNotificationPrompt';

// import { useSelector } from 'react-redux';

// // Import the custom hook
// import { useTokenValidator } from './hooks/useTokenValidator';

 
// const fadeIn = keyframes`
//   from { opacity: 0; transform: translateY(20px); }
//   to { opacity: 1; transform: translateY(0); }
// `;
 
// const float = keyframes`
//   0% { transform: translateY(0px); }
//   50% { transform: translateY(-10px); }
//   100% { transform: translateY(0px); }
// `;
 
// const pulse = keyframes`
//   0% { transform: scale(1); }
//   50% { transform: scale(1.05); }
//   100% { transform: scale(1); }
// `;
 
// const gradientMove = keyframes`
//   0% { background-position: 0% 50%; }
//   50% { background-position: 100% 50%; }
//   100% { background-position: 0% 50%; }
// `;
 
 
// const MobileContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   justify-content: center;
//   height: 100vh;
//   padding: 20px;
//   text-align: center;
//   background: linear-gradient(135deg, #6e8efb, #a777e3, #8a63d2, #5a9bff);
//   background-size: 300% 300%;
//   animation: ${gradientMove} 15s ease infinite;
//   color: white;
//   font-family: 'Arial, sans-serif';
//   overflow: hidden;
// `;
 
// const GlassCard = styled.div`
//   background: rgba(255, 255, 255, 0.2);
//   border-radius: 15px;
//   padding: 30px;
//   box-shadow: 0 8px 32px rgba(31, 38, 135, 0.37);
//   backdrop-filter: blur(4px);
//   border: 1px solid rgba(255, 255, 255, 0.18);
//   max-width: 80%;
//   animation: ${fadeIn} 1s ease-out forwards;
// `;
 
// const ComputerIcon = styled.div`
//   font-size: 50px;
//   margin-bottom: 15px;
//   animation: ${float} 3s ease-in-out infinite;
// `;
 
// const Title = styled.h1`
//   margin: 0 0 20px 0;
//   font-size: 24px;
//   font-weight: bold;
//   animation: ${fadeIn} 1s ease-out 0.3s both;
// `;
 
// const Divider = styled.div`
//   width: 50px;
//   height: 5px;
//   background: #fff;
//   margin: 0 auto 20px;
//   border-radius: 10px;
//   animation: ${fadeIn} 1s ease-out 0.5s both;
// `;
 
// const Paragraph = styled.p`
//   font-size: 16px;
//   line-height: 1.6;
//   margin-bottom: 20px;
//   animation: ${fadeIn} 1s ease-out ${props => props.delay || '0.7s'} both;
// `;
 
// const ButtonContainer = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   margin-top: 20px;
//   animation: ${fadeIn} 1s ease-out 1.1s both;
// `;
 
// const Button = styled.div`
//   display: inline-block;
//   padding: 10px 20px;
//   background: white;
//   color: #6e8efb;
//   border-radius: 50px;
//   font-weight: bold;
//   box-shadow: 0 4px 10px rgba(0,0,0,0.1);
//   animation: ${pulse} 2s infinite;
//   cursor: pointer;
// `;
 
// const ProtectedRoutes = () => {
//     const { isLoading, accessToken } = useTokenValidator(); 
    
//     // 1. If loading, show a fullscreen loader (BLOCKS all API calls)
//     if (isLoading) {
//         return <div style={{height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
//                  Authenticating Session...
//                </div>;
//     }

//     // 2. If token is missing after the refresh check, redirect to login
//     if (!accessToken) {
//         return <Navigate to="/login" replace />;
//     }

//     // 3. Token is fresh (or just refreshed). Render protected content.
//     return (
//         <Routes>
//             {/* Protected Routes */}
//             <Route path='/Employee' element={<EmployeeDashboard />} />
//             <Route path='/Manager' element={<Manager />} />
//             <Route path='/TeamLead' element={<Manager />} />
//             <Route path='/HR' element={<HRDashboard />} />
//             {/* Add any other authenticated routes here */}

//             {/* If a protected route is hit directly and they are logged in, navigate to a default dashboard */}
//             <Route path="*" element={<Navigate to="/Employee" replace />} /> 
//         </Routes>
//     );
// };

// const App = () => {
//   const [isMobile, setIsMobile] = useState(false);
//   const [user, setUser] = useState(null);
 
//   useEffect(() => {
//     const checkIfMobile = () => {
//       setIsMobile(window.innerWidth < 769);
//     };
   
//     checkIfMobile();   
//     window.addEventListener('resize', checkIfMobile);
   
//     return () => window.removeEventListener('resize', checkIfMobile);
//   }, []);

  
//   // Replace your existing service worker useEffect in App.js with this:

// useEffect(() => {
//   if ('serviceWorker' in navigator) {
//     console.log('[SW] Starting service worker registration...');
    
//     navigator.serviceWorker.register('/sw.js')
//       .then(registration => {
//         console.log('[SW] ServiceWorker registration successful:', {
//           scope: registration.scope,
//           state: registration.installing ? 'installing' : 
//                  registration.waiting ? 'waiting' : 
//                  registration.active ? 'active' : 'unknown'
//         });
        
//         // Listen for service worker updates
//         registration.addEventListener('updatefound', () => {
//           console.log('[SW] New service worker version found');
//         });
//       })
//       .catch(err => {
//         console.error('[SW] ServiceWorker registration failed:', err);
//       });
      
//     // Check if service worker is already active
//     navigator.serviceWorker.ready.then(registration => {
//       console.log('[SW] Service worker is ready:', registration.scope);
//     });
    
//   } else {
//     console.warn('[SW] Service workers are not supported in this browser');
//   }
// }, []);

//   const MobileMessage = () => (
//     <MobileContainer>
//       <GlassCard>
//         <ComputerIcon>
//           💻
//         </ComputerIcon>
//         <Title>
//           Desktop Only Application
//         </Title>
//         <Divider />
//         <Paragraph>
//           This application is optimized for desktop viewing only.
//         </Paragraph>
//         <Paragraph delay="0.9s">
//           Please switch to a desktop or laptop to access all features.
//         </Paragraph>
//         <ButtonContainer>
//           <Button>
//             Mobile View Not Supported
//           </Button>
//         </ButtonContainer>
//       </GlassCard>
//     </MobileContainer>
//   );
 
// //   return (
// //     <>
    
// //       {isMobile ? (
// //         <MobileMessage />
// //       ) : (
// //         <Router>
// //           <Routes> 
// //           <Route path="/" element={<LoginPage />} />        
// //             <Route path='/register' element={<RegisterPage />} />
// //             <Route path='/generate-otp' element={<GenerateOTP />} />
           
// //             <Route path="/forgot-password" element={<ForgotPasswordPage />} />
// //             <Route path='/Employee' element={<EmployeeDashboard />} />
// //             <Route path='/Manager' element={<Manager />} />
// //             <Route path='/TeamLead' element={<Manager />} />
// //             <Route path='/HR' element={<HRDashboard />} />
// //             <Route path="/set-password" element={<SetPassword />} />
// //             <Route path="/verify-email/:token" element={<VerifyEmail />} />
// //           </Routes>         
// //         </Router>
// //       )}
// //     </>
// //   );
// // };


// // const App = () => {
 
 
//   return (
//     <>
    
//         <Router>
//           <Routes>
//             <Route path='/' element={<LoginPage />} />
//             <Route path='/register' element={<RegisterPage />} />
//             <Route path='/generate-otp' element={<GenerateOTP />} />
//             <Route path="/login" element={<LoginPage />} />
//             <Route path="/forgot-password" element={<ForgotPasswordPage />} />
//             <Route path='/Employee' element={<EmployeeDashboard />} />
//             <Route path='/Manager' element={<Manager />} />
//             <Route path='/TeamLead' element={<Manager />} />
//             <Route path='/HR' element={<HRDashboard />} />
//             <Route path="/set-password" element={<SetPassword />} />
//             <Route path="/verify-email/:token" element={<VerifyEmail />} />
//           </Routes>
//         </Router>
    
//     </>
//   );
// };
 
// export default App;

import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

// Import the custom hook for proactive refresh
import { useTokenValidator } from './hooks/useTokenValidator';

// Import Pages
import LoginPage from './pages/Authentication/Login';
import ForgotPasswordPage from './pages/Authentication/ForgotPassword';
import EmployeeDashboard from './pages/Employee/Dashboard/EmployeeDashboard';
import HRDashboard from './pages/HR/DashBoard/HRDashboard';
import { Manager } from './pages/Manager/Dashboard/manager';
import VerifyEmail from './pages/Authentication/verifyEmail';
import SetPassword from './pages/Authentication/setPassword';
import RegisterPage from './pages/Authentication/RegistrationPage';
import GenerateOTP from './pages/Authentication/GenerateOTP';
import PushNotificationManager from './components/PushNotificationPrompt';
import TokenExpirePopup from './components/TokenExpirePopup';

/* ----------------------------------------
   STYLED COMPONENTS (same as your file)
----------------------------------------- */

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;
const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;
const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;
const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const MobileContainer = styled.div`
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  height: 100vh; padding: 20px; text-align: center;
  background: linear-gradient(135deg, #6e8efb, #a777e3, #8a63d2, #5a9bff);
  background-size: 300% 300%;
  animation: ${gradientMove} 15s ease infinite;
  color: white; overflow: hidden;
`;

const GlassCard = styled.div`
  background: rgba(255,255,255,0.2);
  border-radius: 15px; padding: 30px;
  box-shadow: 0 8px 32px rgba(31,38,135,0.37);
  backdrop-filter: blur(4px);
  border: 1px solid rgba(255,255,255,0.18);
  max-width: 80%; animation: ${fadeIn} 1s ease-out forwards;
`;
const ComputerIcon = styled.div`
  font-size: 50px; margin-bottom: 15px;
  animation: ${float} 3s ease-in-out infinite;
`;
const Title = styled.h1`
  margin: 0 0 20px; font-size: 24px; font-weight: bold;
  animation: ${fadeIn} 1s ease-out 0.3s both;
`;
const Divider = styled.div`
  width: 50px; height: 5px; background: white;
  margin: 0 auto 20px; border-radius: 10px;
  animation: ${fadeIn} 1s ease-out 0.5s both;
`;
const Paragraph = styled.p`
  font-size: 16px; line-height: 1.6; margin-bottom: 20px;
  animation: ${fadeIn} 1s ease-out ${props => props.delay || '0.7s'} both;
`;
const ButtonContainer = styled.div`
  display: flex; justify-content: center; margin-top: 20px;
  animation: ${fadeIn} 1s ease-out 1.1s both;
`;
const Button = styled.div`
  padding: 10px 20px; background: white; color: #6e8efb;
  border-radius: 50px; font-weight: bold;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  animation: ${pulse} 2s infinite; cursor: pointer;
`;

/* ----------------------------------------
   PROTECTED ROUTE WRAPPER
----------------------------------------- */
const ProtectedRoutes = () => {
  const accessToken = useSelector(state => state.auth.accessToken);

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  return (
    <Routes>
      <Route path="/Employee" element={<EmployeeDashboard />} />
      <Route path="/Manager" element={<Manager />} />
      <Route path="/TeamLead" element={<Manager />} />
      <Route path="/HR" element={<HRDashboard />} />
      <Route path="*" element={<Navigate to="/Employee" replace />} />
    </Routes>
  );
};

/* ----------------------------------------
   NEW WRAPPER → Validator runs INSIDE Router
----------------------------------------- */

const AppContent = () => {
  const { isLoading } = useTokenValidator();
  const [isMobile, setIsMobile] = useState(false);

    const [showTokenExpirePopup, setShowTokenExpirePopup] = useState(false);
  const accessToken = useSelector(state => state.auth.accessToken);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 769);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

   useEffect(() => {
    // Check if we should show token expire popup
    const shouldShowPopup = localStorage.getItem('showTokenExpirePopup');
    if (shouldShowPopup === 'true' && !accessToken) {
      setShowTokenExpirePopup(true);
      localStorage.removeItem('showTokenExpirePopup');
    }
  }, [accessToken]);

  const handleCloseTokenExpirePopup = () => {
    setShowTokenExpirePopup(false);
  };

  if (isLoading) {
    return (
      <div style={{
        height: "100vh", display: "flex",
        justifyContent: "center", alignItems: "center",
        fontSize: "20px", fontWeight: "bold", color: "#6e8efb"
      }}>
        Authenticating Session... Please Wait.
      </div>
    );
  }

  if (isMobile) {
    return (
      <MobileContainer>
        <GlassCard>
          <ComputerIcon>💻</ComputerIcon>
          <Title>Desktop Only Application</Title>
          <Divider />
          <Paragraph>This application is optimized for desktop viewing only.</Paragraph>
          <Paragraph delay="0.9s">Please switch to a desktop or laptop.</Paragraph>
          <ButtonContainer><Button>Mobile View Not Supported</Button></ButtonContainer>
        </GlassCard>
      </MobileContainer>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/generate-otp" element={<GenerateOTP />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/set-password" element={<SetPassword />} />
        <Route path="/verify-email/:token" element={<VerifyEmail />} />
        <Route path="/*" element={<ProtectedRoutes />} />
      </Routes>

      <PushNotificationManager />

       {showTokenExpirePopup && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
        </div>
      )}
    </>
  );
};

/* ----------------------------------------
   MAIN APP — Router WRAPS EVERYTHING
----------------------------------------- */
const App = () => (
  <Router>
    <AppContent />
  </Router>
);

export default App;
